<template>
  <div
    class="g-scroll-wrapper"
    ref="wrapper"
  >
    <slot></slot>
  </div>
</template>

<script type="text/ecmascript-6">
import BScroll from "better-scroll";
import * as util from "assets/js/util";

const DIRECTION_H = "horizontal";
const DIRECTION_V = "vertical";
const NAV_HEIGHT = util.common.calculateWH(60);
export default {
  props: {
    click: {
      type: Boolean,
      default: true
    },
    probeType: {
      type: Number, // probeType值为0,1时，不监听；probeType为2时，手指触摸时监听，惯性滑动不监听；值为3时，都监听
      default: 1
    },
    data: {
      type: [Object, Array],
      default: null
    },
    /**
     * 当数据更新后，刷新scroll的延时。
     */
    refreshDelay: {
      type: Number,
      default: 20
    },
    pullup: {
      type: Boolean,
      default: false
    },
    listenScroll: {
      type: Boolean,
      default: false
    },
    direction: {
      type: String,
      default: DIRECTION_V
    },
    freeScroll: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      directionY: 0
    };
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this._initScroll();
      }, 20);
    });
  },
  methods: {
    getBase() {
      return {
        x: this.scroll.x,
        y: this.scroll.y,
        maxX: this.scroll.maxScrollX,
        maxY: this.scroll.maxScrollY
      };
    },
    enable() {
      this.scroll && this.scroll.enable();
    },
    disable() {
      this.scroll && this.scroll.disable();
    },
    refresh() {
      if (this.scroll) {
        this.scroll.refresh();
      }
    },
    finishPullUp() {
      if (this.scroll) {
        this.scroll.finishPullUp();
      }
    },
    closePullUp() {
      if (this.scroll) {
        this.scroll.closePullUp();
      }
    },
    scrollTo(x, y, time, easing) {
      if (this.scroll) {
        this.scroll.scrollTo(x, y, time, easing);
        this.$emit("scrollTo");
      }
    },
    _initScroll() {
      if (!this.$refs.wrapper) {
        return;
      }
      var defaultOpts = {
        probeType: 3,
        click: this.click
      };
      if (this.freeScroll) {
        defaultOpts.freeScroll = true;
      } else {
        defaultOpts.eventPassthrough =
          this.direction === DIRECTION_V ? DIRECTION_H : DIRECTION_V;
      }
      if (this.pullup) {
        defaultOpts = Object.assign({}, defaultOpts, {
          pullUpLoad: {
            threshold: 60
          }
        });
      }
      this.scroll = new BScroll(this.$refs.wrapper, defaultOpts);
      if (this.listenScroll) {
        let me = this;
        this.scroll.on("scroll", pos => {
          this.directionY = this.scroll.directionY;
          me.$emit("setScroll", pos);
        });
      }
      if (this.pullup) {
        //          this.scroll.on('scrollEnd', () => {
        //            console.log(this.scroll.y);
        //            console.log(this.scroll.maxScrollY);
        //            if (this.scroll.y <= (this.scroll.maxScrollY)) {
        //              this.$emit('scrollToEnd');
        //            }
        //          });
        // this.scroll.on("pullingUp", () => {
        //   this.$emit("pullingUp");
        // });
        this.scroll.on("scrollEnd", () => {
          // 滚动到底部
          if (this.scroll.y <= this.scroll.maxScrollY) {
            // console.log("滚动到底部", this.scroll.y);
            this.$emit("pullingUp");
          }
        });
      }
    }
  },
  watch: {
    data() {
      setTimeout(() => {
        this.refresh();
      }, this.refreshDelay);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" rel="stylesheet/scss">
@import "~assets/scss/compile";

.g-scroll-wrapper {
  height: 100%;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/base/scroll/scroll.vue